// extracted by mini-css-extract-plugin
export default {"component":"styles__component--huBcV","title":"styles__title--Nnoys","actions":"styles__actions--Q3QjW"};